import { LocalStorageKeys, SessionStorageKeys } from "utils/storageKeys";
import { logError, logInfo } from "services/logging";
import { queryClient } from "app/global";
import { currentUserQuery } from "services/users";
import { User } from "services/users/model";
export { LocalStorageKeys, SessionStorageKeys } from "utils/storageKeys";

export function hydrateSessionStorage() {
  try {
    // When openning a new tab we hydrate session storage.
    // We pass data between tabs via local storage.
    const serializedSessionStorage = localStorage.getItem(
      LocalStorageKeys.sessionStorageSnapshot
    );
    if (!serializedSessionStorage) {
      return;
    }

    const savedState = JSON.parse(serializedSessionStorage);
    for (const [key, value] of Object.entries(savedState)) {
      if (key !== SessionStorageKeys.tabId) {
        sessionStorage.setItem(key, value as any);
      }
    }

    localStorage.removeItem(LocalStorageKeys.sessionStorageSnapshot);
  } catch (error) {
    logError("Failed to hydrate session storage from local storage", error);
  }

  const serializedUser = sessionStorage.getItem(SessionStorageKeys.user);
  if (serializedUser) {
    const user = JSON.parse(serializedUser) as User;
    queryClient.setQueryData(currentUserQuery().queryKey, user);
  }
}

export function saveBrowserTabId() {
  try {
    const currentTabId = Number(sessionStorage.getItem(SessionStorageKeys.tabId));
    const newTabId = Math.round(Math.random() * 1000);
    if (currentTabId !== newTabId) {
      logInfo(
        `opened new browser tab or refreshed page (old value = ${currentTabId}, new value = ${newTabId})`
      );
    }

    sessionStorage.setItem(SessionStorageKeys.tabId, String(newTabId));
  } catch (error) {
    logError(error);
  }
}

export function getBrowserTabId(): string | null {
  return sessionStorage.getItem(SessionStorageKeys.tabId);
}
